import { info } from "./init"

export function user() {
  return info().user
}
